import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    // Optional: log error to an external service
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    } else {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      // If a fallback component is provided, render it
      if (fallback) return fallback;

      // Default fallback UI
      return (
        <div style={{ padding: '1rem', color: 'red' }}>
          <h2>Something went wrong.</h2>
          {error && <p><strong>{error.toString()}</strong></p>}
          {errorInfo && <pre>{errorInfo.componentStack}</pre>}
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
